import { render, staticRenderFns } from "./outsourcing.vue?vue&type=template&id=0a0dd576&scoped=true"
import script from "./outsourcing.vue?vue&type=script&lang=js"
export * from "./outsourcing.vue?vue&type=script&lang=js"
import style0 from "./outsourcing.vue?vue&type=style&index=0&id=0a0dd576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0dd576",
  null
  
)

export default component.exports